import { useState } from 'react';

import { hasher } from "frontend/js/alpine/stores/hasher.js";
import api from '@src/../js/api';

export function useGetCustomerQuery() {
    const [loading, setLoading]: any  = useState(false);
    const [error, setError]: any = useState(null);
    const [success, setSuccess]: any  = useState(false);
    const [customer, setCustomer]: any  = useState(null);

    const fetchCustomer = async (customerId: number, customFields: any) => {
        setLoading(true);
        setError(null);
        setSuccess(false);
        const accessToken = localStorage.getItem('accessToken');

        const GET_CUSTOMER_QUERY = `
            query {
              customer(customerAccessToken: "${accessToken}") {
                id
                firstName
                lastName
                acceptsMarketing
                email
                phone
              }
            }
        `;

        try {
            const metafieldKeys = customFields.map((field) => `${field.metafield_namespace}.${field.metafield_key}`);

            const res = await fetch('/api/2024-07/graphql.json', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': api.getStorefrontToken(),
                    'X-MindArc-Hash': hasher.store().getHash('get_customer')
                },
                body: JSON.stringify({
                    query: GET_CUSTOMER_QUERY,
                    variables: {
                    }
                })
            });

            if (!res.ok) {
                throw new Error('Failed to fetch customer');
            }
            const { data, errors } = await res.json();

            if (errors) {
                throw new Error(errors[0].message);
            }

            const transformedCustomer = Object.assign(
                {},
                data.customer,
            );

            setCustomer(transformedCustomer);
        } catch (error: any) {
            console.error(error);
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    return {
        loading,
        error,
        success,
        customer,

        fetchCustomer
    };
}
